<template>
  <div class="reward">
    <div class="prize">
      <div class="rewardTitle"></div>
      <div class="prizeShow">
        <div class="prizes flex-column">
          <img class="prizeImg" src="../../static/images/gift01.png" />
          <div>任意目的地往返机票</div>
        </div>
        <div class="prizes flex-column">
          <img class="prizeImg" src="../../static/images/gift02.png" />
          <div>目的地住宿酒店两晚</div>
        </div>
        <div class="prizes flex-column">
          <img class="prizeImg" src="../../static/images/gift03.png" />
          <div>Q萌可爱拍立得</div>
        </div>
      </div>
      <p class="prizeJoinText text-center">奖品数量有限，抓紧时间参与吧！<br>获得好友祝福，还有机会抽到更多奖品，必中哦！
      </p>
    </div>
    <div @click="appAdvClick" class="appAdv">
      <img class="appAdvImg" src="../../static/images/app_adv.jpg" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Reward",
  props: ["mypoint"],
  data() {
    return {};
  },
  methods: {
    appAdvClick(){
      // console.log(this.mypoint)
      this._deepmain(this.pageId, this.mypoint, 2,function(){
        window.location.href = 'http://cp.jegotrip.com.cn/partners/Agoda/app.html?actName=2020wishes';
      });
    }
  },
  created() {}
};
</script>
<style scoped lang="scss" src="../../static/scss/reward.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>

 